module.exports = __webpack_public_path__ + "static/media/insurance-institute.b9e0d93b.png";